import { render, staticRenderFns } from "./AccountName.vue?vue&type=template&id=a2aed9a2&scoped=true&"
import script from "./AccountName.vue?vue&type=script&lang=js&"
export * from "./AccountName.vue?vue&type=script&lang=js&"
import style0 from "./AccountName.vue?vue&type=style&index=0&id=a2aed9a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2aed9a2",
  null
  
)

export default component.exports